import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateTask } from "../../Redux/GetSlice";
import DatePicker from "react-datepicker";
import { useTaskData } from "../../hooks/useTaskData";
import axios from "axios";
import { useSelector } from "react-redux";

export default function TaskStatusNextStep({
  currentTaskId,
  handleChange,
  setSelectedStatusNextStepDate,
  selectedReminderDate,
  isReminder,
  selectedStatusNextStepDate,
  setSelectedReminderDate,
  taskItem,
  getTaskMail,
  nextStepNote,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [updateDeadline, setUpdateDeadline] = useState(false);
  const [customDate, setCustomDate] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [panelPosition, setPanelPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const anchorRef = useRef(null);
  const panelRef = useRef(null);
  const dispatch = useDispatch();
  const { note } = useSelector((state) => state?.redux);
  const {
    selectedReminderDate: reduxSelectedReminderDate,
    selectedStatusNextStepDate: reduxSelectedStatusNextStepDate,
    notes: reduxNote,
    notesText,
    myDayDate,
    deadlineDate,
    isMyDayChecked,
    isDeadlineChecked,
    updateSelectedMyDayPlanDate,
    updateSelectedReminderDate: updateSelectedReminderDateRedux,
    updateSelectedStatusNextStepDate: updateSelectedStatusNextStepDateRedux,
    updateNote,
    updateNotesText,
    updateMyDayDate,
    updateDeadlineDate,
    updateIsMyDayChecked,
    updateIsDeadlineChecked,
    handleDateSelect: handleDateSelectFromHook,
    handleUpdateTask: handleUpdateTaskFromHook,
  } = useTaskData();

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideDropdown = dropdownRef.current && dropdownRef.current.contains(event.target);
      const clickedInsidePanel = panelRef.current && panelRef.current.contains(event.target);
      if (!clickedInsideDropdown && !clickedInsidePanel) {
        if (isOpen && currentTaskId) {
          handleUpdateNotes();
        }
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [taskItem, note, isOpen, currentTaskId]);

  const getFormattedDate = (dateOption) => {
    if (
      dateOption &&
      typeof dateOption === "object" &&
      "daysToAdd" in dateOption
    ) {
      const date = new Date();
      date.setDate(date.getDate() + dateOption.daysToAdd);
      date.setHours(dateOption.time.hours, dateOption.time.minutes, 0, 0);
      return date;
    }
    return dateOption;
  };

  const handleReminderSelection = (dateOption) => {
    const dateObj = new Date(getFormattedDate(dateOption));
    const formattedDate = dateObj.toISOString();
    updateSelectedStatusNextStepDateRedux(formattedDate);
    if (setSelectedStatusNextStepDate) {
      setSelectedStatusNextStepDate(formattedDate);
    }

    setIsOpen(false);
    handleUpdateTaskFromHook(formattedDate, "statusNextStep", taskItem);
  };

  const formatDateForDisplay = (date) => {
    if (!date) return "";
    return date.toLocaleString("en-US", {
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const today = { daysToAdd: 0, time: { hours: 12, minutes: 0 } };
  const tomorrow = { daysToAdd: 1, time: { hours: 8, minutes: 0 } };
  const inTwoDays = { daysToAdd: 2, time: { hours: 8, minutes: 0 } };
  const nextWeek = { daysToAdd: 7, time: { hours: 8, minutes: 0 } };

  const handleDateChange = (date) => {
    setCustomDate(date);
    setShowDatePicker(false);
    handleReminderSelection(date);
  };

  const currentNote = reduxNote !== undefined ? reduxNote : note;
  const currentHandleChange = (e) => {
    const newValue = e.target.value;
    updateNote(newValue);
  };

  const handleUpdateNotes = async () => {
    try {
      const data = {
        notes: note,
      };
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/task/updateTask/${currentTaskId}`,
        data
      );
      if (getTaskMail) {
        getTaskMail();
      }
    } catch (error) {
      console.error("TaskStatusNextStep - Error updating task:", error);
      throw error;
    }
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <a
        href="#"
        ref={anchorRef}
        className="text-listdrop !text-[13px]"
        style={{ textDecoration: "none", display: "inline-block" }}
        onClick={(e) => {
          e.preventDefault();
          if (!isOpen && anchorRef.current) {
            const rect = anchorRef.current.getBoundingClientRect();
            const panelWidth = Math.min(260, window.innerWidth - 16);
            const panelHeight = 400;

            let left = rect.left;
            if (left + panelWidth > window.innerWidth - 8) {
              left = window.innerWidth - panelWidth - 8;
            }
            if (left < 8) left = 8;

            let top = rect.bottom + 4;
            if (top + panelHeight > window.innerHeight - 8) {
              top = Math.max(8, rect.top - panelHeight - 4);
            }

            setPanelPosition({ top, left });
            updateNote(nextStepNote || "");
          }
          setIsOpen(!isOpen);
        }}
      >
        Next Step...
        {reduxSelectedStatusNextStepDate && (
          <div className="mt-1 text-gray-500">
            {formatDateForDisplay(new Date(reduxSelectedStatusNextStepDate))}
          </div>
        )}
        {currentNote && (
          <div className="mt-1 text-gray-500 break-words whitespace-pre-wrap max-w-xs">
            {currentNote}
          </div>
        )}
      </a>

      {isOpen && ReactDOM.createPortal(
        <div
          ref={panelRef}
          className="bg-white shadow-lg rounded-md p-3"
          style={{
            position: "fixed",
            top: `${panelPosition.top}px`,
            left: `${panelPosition.left}px`,
            width: "260px",
            maxWidth: "calc(100vw - 16px)",
            maxHeight: "calc(100vh - 16px)",
            overflowY: "auto",
            zIndex: 10000,
          }}
        >
          <div
            className="flex justify-between items-center mb-3"
            style={{ padding: "8px" }}
          >
            <span
              className="font-medium text-sm text-gray-800"
              style={{
                textDecoration: "none",
                fontSize: "11px",
                fontWeight: 700,
                fontFamily: "inherit",
              }}
            >
              Status and Next Step...
            </span>
            <button
              className="text-blue-500 text-sm"
              onClick={() => setIsOpen(false)}
              style={{
                fontSize: "11px",
                fontWeight: "700",
                fontFamily: "inherit",
              }}
            >
              Clear
            </button>
          </div>
          <div>
            <textarea
              placeholder="Add an optional note or next step"
              className="w-full border border-gray-200 rounded p-2 text-sm resize-none mb-2"
              rows={2}
              value={currentNote}
              onChange={currentHandleChange}
              style={{ backgroundColor: "white" }}
            ></textarea>
          </div>
          <div>
            <ul className="text-xs text-gray-800 divide-y divide-gray-100 px-0 mb-0">
              <li
                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                onClick={() => handleReminderSelection(today)}
              >
                <span className="flex items-center gap-2">
                  <i className="bi bi-sun-fill text-gray-900"></i>
                  <span className="text-xs">Later today</span>
                </span>
                <span className="text-xs text-gray-500 font-medium">
                  {formatDateForDisplay(getFormattedDate(today))}
                </span>
              </li>

              <li
                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                onClick={() => handleReminderSelection(tomorrow)}
              >
                <span className="flex items-center gap-2">
                  <i className="bi bi-moon-stars-fill text-gray-500"></i>
                  <span className="text-xs">Tomorrow</span>
                </span>
                <span className="text-xs text-gray-500 font-medium">
                  {formatDateForDisplay(getFormattedDate(tomorrow))}
                </span>
              </li>

              <li
                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                onClick={() => handleReminderSelection(inTwoDays)}
              >
                <span className="flex items-center gap-2">
                  <i className="bi bi-clock-fill text-gray-500"></i>
                  <span className="text-xs">In two days</span>
                </span>
                <span className="text-xs text-gray-500 font-medium">
                  {formatDateForDisplay(getFormattedDate(inTwoDays))}
                </span>
              </li>

              <li
                className="flex items-center justify-between px-2 py-2 cursor-pointer hover:bg-gray-50"
                onClick={() => handleReminderSelection(nextWeek)}
              >
                <span className="flex items-center gap-2">
                  <i className="bi bi-calendar-week-fill text-gray-500"></i>
                  <span className="text-xs">Next week</span>
                </span>
                <span className="text-xs text-gray-500 font-medium">
                  {formatDateForDisplay(getFormattedDate(nextWeek))}
                </span>
              </li>

              <li
                className="flex items-center px-2 py-2 cursor-pointer hover:bg-gray-50"
                onClick={() => setShowDatePicker(!showDatePicker)}
              >
                <span className="flex items-center gap-2">
                  <i className="bi bi-calendar-event-fill text-gray-500"></i>
                  <span className="text-xs">Pick a date</span>
                </span>
              </li>

              {showDatePicker && (
                <li>
                  <div className="absolute left-1/2 top-0 -translate-x-1/2 mt-2 z-50 bg-white rounded-xl shadow-2xl border border-gray-200 p-2">
                    <DatePicker
                      selected={customDate}
                      onChange={handleDateChange}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="MMMM d, yyyy h:mm aa"
                      placeholderText="Select date and time"
                      className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                      calendarClassName="!border-0 !shadow-none"
                      inline
                      minDate={new Date()}
                    />
                  </div>
                </li>
              )}
            </ul>
          </div>
          <div className="mt-3 p-2">
            <label className="flex items-center text-sm gap-2">
              <input
                type="checkbox"
                checked={updateDeadline}
                onChange={() => setUpdateDeadline(!updateDeadline)}
                style={{ backgroundColor: "white" }}
              />
              Also update the deadline date
            </label>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}
